import React, { useState } from "react"
import { Info } from "lucide-react"

export const ToolTip = ({ size = 16, className = "", fetchTooltipContent }) => {
  const [message, setMessage] = useState("")
  const [showTooltip, setShowTooltip] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    setShowTooltip(true)

    // Don't call API again if data already loaded
    if (message) return

    try {
      setLoading(true)

      const data = await fetchTooltipContent()

      // adjust according to your API response
      setMessage(data)
    } catch (error) {
      setMessage("Failed to load data")
    } finally {
      setLoading(false)
    }
  }

  return (
    <span className={`tooltip-container ${className}`}>
      <Info
        size={size}
        color="grey"
        onClick={handleClick}
        style={{
          verticalAlign: "middle",
          cursor: "pointer",
        }}
      />

      {showTooltip && (
        <span className="tooltip-text">{loading ? "Loading..." : message}</span>
      )}
    </span>
  )
}
